import Vue from "vue";
import Swal from "sweetalert2";

// axios
import axios from "axios";
const endpoint = process.env.VUE_APP_ENDPOINT
  ? process.env.VUE_APP_ENDPOINT
  : `http://localhost:3107"`;

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: '/api',
  // baseURL: 'https://5f45-2001-448a-2020-3be3-81d8-774f-f420-6a31.ap.ngrok.io/hms/api',
  baseURL: endpoint,
  // timeout: 1000,
  headers: {
    "ngrok-skip-browser-warning": true,
    "Content-Type": "application/json",
  },
});

axiosIns.interceptors.request.use(
  (config) => {
    const token_auth = localStorage.getItem("ugems-accessToken");
    if (token_auth) {
      config.headers.Authorization = `Bearer ${token_auth}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosIns.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response && error.response.status >= 500 && error.response.status < 600) {
      /*Swal.fire({
        icon: "error",
        title: "Server Error",
        text: 'Sistem ubudget  terkendala untuk mendapatkan data vendor dari SAP. Mohon hubungi tim Digitech unuk informasi lebih lanjut'
        //text: "Sistem mengalami kendala saat berkomunikasi dengan layanan eksternal. Mohon hubungi tim IT untuk investigasi lebih lanjut.",
      });*/
        Swal.fire({
            //icon: "error",
            //title: "Server Error",
            text: 'Ada kendala ke backend ubudget, silahkan refresh atau hubungi digitech jika masih berlanjut',
            toast: true,
            position: "bottom-left",
            showConfirmButton: false,
            showCloseButton: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer)
                toast.addEventListener("mouseleave", Swal.resumeTimer)
            },
            customClass: {
                htmlContainer: 'swal-text-small',
                popup: 'swal-toast-width swal-toast-red-close',
            }
        });
    }
    // if(!(router.history.current.path).includes("login") && error.response.status == 401){
    //   console.log('path is not login & status code 401');

    //   // Remove userData from localStorage
    //   localStorage.removeItem('userData')

    //   // Redirect to login page
    //   router.push({ name: 'auth-login' })
    // }
    // console.log(`error : ${error.response.status}`);
    return Promise.reject(error);
  }
);

Vue.prototype.$http = axiosIns;

export default axiosIns;
